import {
  ConnectionTypeEnum,
  RequestStatusEnum,
  ServiceTypeEnum,
} from "src/components/Premises/types";
import {
  CloseTransferStatusEnum,
  DocumentTypeEnum,
  HandoverTypeEnum,
} from "../types";

export interface CloseTransferData {
  journey_id: string;
  service_type: ServiceTypeEnum;
  earliest_date: Date | undefined; // [year, month, day]
  chosen_action: HandoverTypeEnum;
  close_transfer_status: CloseTransferStatusEnum;
  id: string;
  request_status: RequestStatusEnum;
  connection_type: ConnectionTypeEnum;
  nmi_mirn: string;
  updater_name?: string;
  updated?: number;
  requester_name: string;
  submitted: number;
  // legacy flow
  attachment_meta?: {
    id: string;
    file_upload_type: DocumentTypeEnum.NEW_ENERGY_ACCOUNT_FORM;
    file_upload_type_affix: string;
    file_name: string;
    link: string;
  };
  // new flow
  customer_first_name: string | undefined;
  customer_last_name: string | undefined;
  customer_email: string | undefined;
}

export enum CloseTransferWarningModalMessageType {
  NOT_REQUIRED = "NOT_REQUIRED",
  PROCESSED = "PROCESSED",
}
